<template>
  <giminystes-rysiai />
  <dovanojimo-sutartis />
  <ikurta-partija />
  <santuokos-nutraukimas />
  <separacija />
  <div class="navigation">
    <div class="next-posts">
      <router-link to="/straipsniai">« Naujesni įrašai</router-link>
    </div>
    <div class="prev-posts">
      <router-link to="/straipsniai/page/3">Senesni įrašai »</router-link>
    </div>
  </div>
</template>

<script>
import GiminystesRysiai from './Articles/GiminystesRysiai.vue'
import DovanojimoSutartis from './Articles/DovanojimoSutartis.vue'
import IkurtaPartija from './Articles/IkurtaPartija.vue'
import SantuokosNutraukimas from './Articles/SantuokosNutraukimas.vue'
import Separacija from './Articles/Separacija.vue'
export default {
  components: {
    DovanojimoSutartis,
    GiminystesRysiai,
    SantuokosNutraukimas,
    Separacija,
    IkurtaPartija
  }
}
</script>
